import { Grid, withStyles } from '@material-ui/core';
import React from "react";
import constants from "./constants";
import { Action, DispatchInput, Header, Notes, DefectDetails } from "./components";
import { getTractorError } from "./utils";
import { EQUIPMENT_DEFECTS_GRID_FILTER } from "./EquipmentDefects/constants";

const styles = (theme) => ({
  container: {
    flexGrow: 1,
    overflowY: 'auto'
  }
});

class DispatchBobtail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tractor: null,
      routeName: null,
      notes: "",
      tractorError: "",
    };
  }

  componentDidUpdate(prevProps){
    if(prevProps.tractorList !== this.props.tractorList){
      if(this.state.tractor){
        this.setState({
          tractorError: getTractorError({
            tractor: this.state.tractor, 
            tractorStatusConfig: this.props.tractorStatusConfig,
          })
        })
      }
    }
  }

  updateTractor = (tractor) => {
    this.setState({
      tractor: tractor,
      tractorError: getTractorError({
        tractor,
        tractorStatusConfig: this.props.tractorStatusConfig,
      }),
    });
  };

  updateRouteName = (route) => {
    const routeName = route?.value ?? null;
    this.setState({
      routeName,
    });
  };

  updateNotes = (notes) => {
    this.setState({
      notes,
    });
  };

  isValidTractor = () => {
    const tractorError = getTractorError({
      tractor: this.state.tractor,
      tractorStatusConfig: this.props.tractorStatusConfig,
    });
    this.setState({
      tractorError
    });
    return !Boolean(tractorError);
  };

  dispatchBobtail = () => {
    const data = this.isValidTractor()
      ? {
          notes: this.state.notes,
          tractorId: this.state.tractor.value,
          trailerDetails: [
            {
              trailerId: constants.TRAILER_NUMBER_FOR_BOBTAIL,
              manifestNumber: null,
              dollyId: null,
              routeName: this.state.routeName,
            },
          ],
        }
      : null;
    this.props.dispatchDriver(data);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <Grid className={`${classes.container} customScroll`}>
        <Header label={"TRACTOR DETAILS"} />
          <DispatchInput
            label="Tractor #"
            autoFocus={true}
            value={this.state.tractor?.label ?? null}
            options={this.props.tractorList}
            onChange={this.updateTractor}
            error={this.state.tractorError}
            isLoading={this.props.isLoading}
          />
          {Boolean(this.state.tractor?.defects?.length) && (
            <DefectDetails
              defects={this.state.tractor?.defects}
              equipmentType="tractors"
              openDvirReports={this.props.openDvirReports(
                EQUIPMENT_DEFECTS_GRID_FILTER.tractor
              )}
            />
          )}
          <DispatchInput
            label="Route Name"
            autoFocus={false}
            value={this.state.routeName}
            options={this.props.routeList}
            onChange={this.updateRouteName}
          />
          <Notes value={this.state.notes} onChange={this.updateNotes} />
          {this.props.children}
        </Grid>

        <Action
          cancel={this.props.cancel}
          confirm={this.dispatchBobtail}
          disableButton={this.props.disableDispatch}
        />
      </>
    );
  }
}

export default withStyles(styles)(DispatchBobtail);
